import * as React from 'react';
import { C as Context } from './injectIntl-BtqeBzQq-DKO65rGD.js';
import { i as invariantIntlContext } from '../utils-DeBP9s6c-DpFbgjLE.js';

function useIntl() {
  var intl = React.useContext(Context);
  invariantIntlContext(intl);
  return intl;
}

export { useIntl as u };
//# sourceMappingURL=useIntl-BGx4v_Uj-CJNeXUZQ.js.map
